import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'create-chat-inbox-task');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'providers',
  type: 'post',
  slug: ['inbox_tasks', 'chats'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/create-chat-inbox-task-req.js